/**
 * Footer pager for the listings card.
 *
 * Client-side only: `GET /api/admin/listings` returns the organization's rows
 * uncapped, so the whole list is already in memory and paging is a slice.
 * Follows the range-plus-prev/next shape the other client-paged admin lists
 * use (see `components/admin/InventorySection`).
 */
import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const NAV =
  "inline-flex h-8 w-8 items-center justify-center rounded-lg border border-border text-foreground hover:bg-muted focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-40";

export default function ListingsPagination({
  page,
  pageCount,
  total,
  from,
  to,
  onPrev,
  onNext,
}) {
  if (total === 0) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 border-t border-border px-4 py-3">
      <span className="text-xs text-muted-foreground">
        {from}–{to} von {total} {total === 1 ? "Listing" : "Listings"}
      </span>

      {pageCount > 1 ? (
        <div className="flex items-center gap-2">
          <button type="button" onClick={onPrev} disabled={page === 0} className={NAV} aria-label="Vorherige Seite">
            <ChevronLeft aria-hidden="true" className="h-4 w-4" />
          </button>
          <span className="text-xs text-muted-foreground">
            Seite {page + 1} von {pageCount}
          </span>
          <button
            type="button"
            onClick={onNext}
            disabled={page >= pageCount - 1}
            className={NAV}
            aria-label="Nächste Seite"
          >
            <ChevronRight aria-hidden="true" className="h-4 w-4" />
          </button>
        </div>
      ) : null}
    </div>
  );
}
